import React from 'react';
import { Outlet } from 'react-router-dom';
import { HeaderNavbar } from 'modules';
import {
  Box,
  Container
} from '@mui/material';



type Props = {};

export const ThemeLayout = (props: Props) => {

  return (
    <>
      <HeaderNavbar.FC />
      <Box>
        <Outlet />
      </Box>
    </>
  );
};
